import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';

import { SettingsService } from './core/settings/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { MongoObservable } from 'meteor-rxjs';
import { ThemesService } from './core/themes/themes.service';
import { Subscription } from 'rxjs';
import { MeteorUser } from '../../../backend/server/data-models/meteor-user/meteor-user';

import 'flot/jquery.flot'
require('flot/jquery.flot');

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    @HostBinding('class.layout-fixed') get isFixed() { return this.settings.getLayoutSetting('isFixed'); };
    @HostBinding('class.aside-collapsed') get isCollapsed() { return this.settings.getLayoutSetting('isCollapsed'); };
    @HostBinding('class.layout-boxed') get isBoxed() { return this.settings.getLayoutSetting('isBoxed'); };
    @HostBinding('class.layout-fs') get useFullLayout() { return this.settings.getLayoutSetting('useFullLayout'); };
    @HostBinding('class.hidden-footer') get hiddenFooter() { return this.settings.getLayoutSetting('hiddenFooter'); };
    @HostBinding('class.layout-h') get horizontal() { return this.settings.getLayoutSetting('horizontal'); };
    @HostBinding('class.aside-float') get isFloat() { return this.settings.getLayoutSetting('isFloat'); };
    @HostBinding('class.offsidebar-open') get offsidebarOpen() { return this.settings.getLayoutSetting('offsidebarOpen'); };
    @HostBinding('class.aside-toggled') get asideToggled() { return this.settings.getLayoutSetting('asideToggled'); };
    @HostBinding('class.aside-collapsed-text') get isCollapsedText() { return this.settings.getLayoutSetting('isCollapsedText'); };

    private userSubscription: Subscription;

    constructor(
        private settings: SettingsService,
        private translateService: TranslateService,
        private themesService: ThemesService
    ) { }

    ngOnInit() {
        document.addEventListener('click', e => {
            const target = e.target as HTMLElement;
            if (target.tagName === 'A') e.preventDefault();
        })

        this.userSubscription = new MongoObservable.Collection<MeteorUser>(Meteor.users).find()
            .subscribe((users: MeteorUser[]) => {
                if (users.length !== 1) return;
                const user = users[0];
                // console.warn("USER CHANGING"); console.warn(user);
                if (user.profile) {
                    if (user.profile.lang) {
                        this.translateService.use(user.profile.lang);
                    }
                    if (user.profile.layout && user.profile.layout.theme) {
                        this.themesService.setTheme(user.profile.layout.theme);
                    }
                }
            });
    }

    ngOnDestroy(): void {
        if (this.userSubscription) this.userSubscription.unsubscribe();
    }

}
